// extracted by mini-css-extract-plugin
export default {"wrapper":"oB-z","viewport":"pB-z","container":"qB-z","slide":"rB-z"};